<template>
	<div id="controleIntimacao">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="3">
				<a-row>
					<span class="tr-label">Filtrar data por:</span>
				</a-row>
				<a-row>
					<a-select 
						default-value="0" 
						:value="tipoData" 
						@change="handleTipoData" 
						:disabled="loading" 
						style="width: 90%">
							<a-select-option value="0">Envio Kurier</a-select-option>							
							<a-select-option value="1">Evento da Intimação</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span class="tr-label">Cliente:</span>
				</a-row>
				<a-row>
					<a-select
						show-search
						option-filter-prop="children"
						style="width: 90%"
						@change="handleClienteChange"
						:disabled="loading"
						:value="valueCliente"
						:allowClear="(valueCliente!=null && valueCliente!=undefined)"
						>
						<a-select-option v-for="cli in clientes" :key="cli.idCliente">
							{{cli.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span>Inicial:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataIncial"
						placeholder="Data Incial"
						style="width: 85%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span>Final:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataFinal"
						placeholder="Data Final"
						style="width: 85%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span>NPU:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 90%;"
						v-model="valueNPU"						
						@change="onChangeNPU"						
						:disabled="loading"						
						:allowClear="valueNPU!=null"
						v-mask="'#######-##.####.#.##.####'"
						>					
					</a-input>
				</a-row>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span>Usuário:</span>
				</a-row>
				<a-row>
					<a-select 					
						style="width: 90%"
						@change="handleUsuarioChange"
						:disabled="loading"
						:value="valueUsuario"
						:allowClear="(valueUsuario!=null && valueUsuario!=undefined)"
						>
						<a-select-option v-for="usu in usuarios" :key="usu.idUsuario">
							{{usu.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
		</a-row>
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="6">
				<a-row>
					<span>Perfil:</span>
				</a-row>
				<a-row>
					<a-select 					
						style="width: 90%"
						@change="handlePerfilTribunalChange"
						:disabled="loading"
						:value="valuePerfilTribunal"
						:allowClear="(valuePerfilTribunal!=null && valuePerfilTribunal!=undefined)"
						>
						<a-select-option v-for="perfilTribunal in perfisTribunal" :key="perfilTribunal.idPerfilTribunal">
							{{perfilTribunal.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="2" style="text-align: right;">
				<a-button
					class="tr-search-btn"
					type="primary"
					@click.prevent="pesquisar"
					:disabled="loading"
				>Pesquisar</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 280px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table              				
				style="width: 100%;"
				:columns="columns"
				:rowKey="record => record.idCliente"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template 
					slot="uf" 
					slot-scope="uf, record"
				>{{record.uf.substring(0, 2)}}</template>
				<template
					slot="dataCadastro"
					slot-scope="dataCadastro, record"
				>{{formatarDataLocal(record.dataCadastro, true, 'DD/MM/YYYY HH:mm:ss')}}</template>
				<template
					slot="enviado"
					slot-scope="enviado, record"
				>{{record.enviado ? 'SIM' : 'NÃO'}}</template>
				<template
					slot="dataEnvio"
					slot-scope="dataEnvio, record"
				>{{formatarDataLocal(record.dataEnvio, true, 'DD/MM/YYYY HH:mm:ss')}}</template>
			</a-table>
			<div class="excel" ref="modalDetalhamentoExcel">
				<a-tooltip :getPopupContainer="() => $refs.modalDetalhamentoExcel" placement="topLeft">
					<template slot="title">Exportar Excel</template>
					<a-button
						type="primary"
						shape="circle"
						icon="file-excel"
						size="default"
						@click.stop.prevent="exportarExcel"
						:disabled="loading"
						:style="{textAlign: 'center', position: 'relative', top: data.length > 0 ? '-50px' : '5px', left: '5px'}"
					/>
				</a-tooltip>
			</div>
		</a-row>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import moment from "moment";
import {mask} from 'vue-the-mask';
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columns = [
	{    
		title: "Usuário",
		dataIndex: "nomeUsuario",
		align: "left",
		scopedSlots: { customRender: "nomeUsuario" },
		width: "17%",
		sorter: (a, b) => a.nomeUsuario.localeCompare(b.nomeUsuario)
	},
	{    
		title: "Perfil",
		dataIndex: "nomePerfilTribunal",
		align: "left",
		scopedSlots: { customRender: "nomePerfilTribunal" },
		width: "17%",
		sorter: (a, b) => a.nomePerfilTribunal.localeCompare(b.nomePerfilTribunal)
	},
	{
		title: "NPU",
		dataIndex: "numeroProcesso",
        align: "left",
		width: "15%",
        scopedSlots: { customRender: "numeroProcesso" },
		sorter: (a, b) => a.numeroProcesso.localeCompare(b.numeroProcesso)
	},
	{
		title: "Tipo Intimação",
		dataIndex: "tipoIntimacao",
        align: "left",
		width: "10%",
        scopedSlots: { customRender: "tipoIntimacao" },
		sorter: (a, b) => a.tipoIntimacao.localeCompare(b.tipoIntimacao)
	},
	{
		title: "Data Cadastro",
		dataIndex: "dataCadastro",
        align: "center",
		width: "11%",
        scopedSlots: { customRender: "dataCadastro" },
		sorter: (a, b) => moment(a.dataCadastro) - moment(b.dataCadastro)
	},
	{    
		title: "Esfera",
		dataIndex: "esfera",
		align: "left",
        width: "6%",
		scopedSlots: { customRender: "esfera" },		
		sorter: (a, b) => a.esfera.localeCompare(b.esfera)
	},
	{    
		title: "UF",
		dataIndex: "uf",
		align: "left",
        width: "5%",
		scopedSlots: { customRender: "uf" },		
		sorter: (a, b) => a.uf.localeCompare(b.uf)
	},
	{
		title: "Enviado",
		dataIndex: "enviado",
        align: "center",
		width: "5%",
        scopedSlots: { customRender: "enviado" }		
	},
    {
		title: "Data Envio",
		dataIndex: "dataEnvio",
        align: "center",
		width: "11%",
        scopedSlots: { customRender: "dataEnvio" }		
	},
];

export default {	
	directives: {mask},	
	name: "controleIntimacao",
	data() {
		return {			
			idTela: 9,
			data: [],
			pagination: {},
			loading: false,
			dateFormat: "DD/MM/YYYY",
			columns,
			clientes:[],			
			usuarios:[],
			perfisTribunal:[],
			valueCliente: null,
			valueUsuario: null,
			valuePerfilTribunal: null,
            valueEnviado: null,
			valueDataInicial: null,
			valueDataFinal: null,
			valueNPU: null,
			tipoData: '0'
		};
	},
	mounted() {
		this.recuperarClientes();
	},
	methods: {
		handleClienteChange(value) {
			this.data = [];
			this.usuarios = [];
			this.valueUsuario = null;
			this.perfisTribunal = [];
			this.valuePerfilTribunal = null;
			this.valueCliente = value;			
			this.recuperarUsuario(value);
		},
		handleTipoData(value) {
			this.data = [];
			this.tipoData = value;
		},
		handleUsuarioChange(value) {
			this.data = [];
			this.perfisTribunal = [];
			this.valuePerfilTribunal = null;
			this.valueUsuario = value;
			this.recuperarPerfilTribunal(value);
		},
		handlePerfilTribunalChange(value) {
			this.data = [];
			this.valuePerfilTribunal = value;
		},
		onChangeDataIncial(date, dateString) {
			this.valueDataInicial = dateString == '' ? null : date;
			this.data = [];
		},
		onChangeDataFinal(date, dateString) {
			this.valueDataFinal = dateString == '' ? null : date;
			this.data = [];
		},
		onChangeNPU() {
			this.data = [];
		},
		recuperarClientes() {
			IntimacaoWebApi.getListarClientes().then(res => {
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Controle Intimação", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Controle Intimação", res.data.result);
				} else {
					this.clientes = res.data.result;
				}
			});
		},
		recuperarUsuario(idCliente) {
			if (idCliente != undefined && idCliente != null){
				IntimacaoWebApi.getUsuarioCliente(idCliente).then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Controle Intimação", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Controle Intimação", res.data.result);
					} else {
						this.usuarios = res.data.result;
					}
				});
			}
		},
		recuperarPerfilTribunal(idUsuario) {
			if (idUsuario != undefined && idUsuario != null){
				IntimacaoWebApi.getPerfilTribunalExibicaoUsuario(idUsuario).then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Controle Intimação", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Controle Intimação", res.data.result);
					} else {
						this.perfisTribunal = res.data.result;
					}
				});
			}
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
		},
		pesquisar() {
			if (this.valueCliente == null || this.valueCliente == undefined)
			{
				showNotificationError(this, "Controle Intimação", "Cliente é um campo obrigatório.");
				return;
			}
			this.data = [];
			this.loading = true;
			let filtro = { idCliente: this.valueCliente,
						   dataInicial: this.valueDataInicial,
						   dataFinal: this.valueDataFinal,
						   NPU: this.valueNPU,
						   idUsuario: this.valueUsuario != null ? this.valueUsuario : 0,
						   idPerfilTribunal: this.valuePerfilTribunal != null ? this.valuePerfilTribunal : 0,
                           enviado: this.valueEnviado != null? this.valueEnviado : -1,
						   tipoFiltroData: this.tipoData };
			IntimacaoWebApi.controleIntimacoes(filtro).then(res => {
				this.loading = false;				
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Controle Intimação", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Controle Intimação", res.data.result);
				} else {
					this.data = res.data.result;					
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {				
				this.loading = false;
				showNotificationError(this, "Controle Intimação", "Erro Controle Intimação.");
			});
		},
		exportarExcel() { 
			const ids = this.data
			.map(item => item.idIntimacao);
			this.loading = true;
			let relatorio = {
				listaId: ids,
				titulo: "Relatório Intimações.xlsx"
			};
			IntimacaoWebApi.exportarRelatorioIntimacoes(relatorio)
				.then(res => {
					this.loading = false;
					let data = res.data;					
					if (data !== null && typeof data !== "undefined") {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);						
						link.download = "Relatório_Intimações_" + new Date().toLocaleDateString() + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					} else {
						showNotificationError(this, "Controle Intimações", "Erro ao tentar gerar arquivo.");
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Controle Intimações", "Erro ao tentar gerar arquivo.");
				});
			// this.loading = true;
			// let listaRetorn = this.dadosDetalhados.map( d => { 
			// 	return {
			// 		produto: this.nomeProdutoSelec,
			// 		poderJudiciario: this.poderJudiciarioSelec,
			// 		codigoEstado: this.codigoEstadoSelec,
			// 		divisaoTribunal: this.divisaoTribunalSelect,
			// 		numeracaoProcessualUnica: d.numeracaoProcessualUnica,
			// 		dataInclusao: this.formatarDataLocal(d.dataInclusao, false),
			// 		horaInclusao: this.formatarDataLocal(d.horaInclusao, true, 'HH:mm:ss')
			// 	};
			// });
			// let relatorio = {
			// 	lista: listaRetorn,
			// 	titulo: "Relatório Fila Pesquisa"
			// };
			// TribunalWebApi.exportarRelatorioFilaPesquisa(relatorio)
			// 	.then(res => {
			// 		this.loading = false;
			// 		let data = res.data;
			// 		if (data !== null && typeof data !== "undefined") {
			// 			let blob = new Blob([res.data], {
			// 				type: "application/vnd.ms-excel"
			// 			});
			// 			let link = document.createElement("a");
			// 			link.href = window.URL.createObjectURL(blob);
			// 			link.download = "Relatório_Fila_Pesquisa_" + new Date().toLocaleDateString() + ".xlsx";
			// 			document.body.appendChild(link);
			// 			link.click();
			// 			document.body.removeChild(link);
			// 		}
			// 	})
			// 	.catch(res => {
			// 		this.loading = false;
			// 		showNotificationError(this, "Relatório Fila Pesquisa", "Erro ao tentar gerar arquivo.");
			// 	});
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
	},
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
</style>

<style>
.controleIntimacao-form-button {
	width: 100px;
}
</style>
